// extracted by mini-css-extract-plugin
module.exports = {"retroTitle":"index_retroTitle__E8t5W"};